import Swal from 'sweetalert2';
import { getApiErrorMessage } from '../utils/apiErrorUtils';
import { toast } from 'react-toastify';
import Loading from '../components/Loading';
import React, {useEffect, useState} from 'react';
import axios from 'axios';
import HomeTitle from '../components/Home/HomeTitle';
import HomeNoShop from '../components/Home/HomeNoShop';
import HomeCardLink from '../components/Home/HomeCardLink';
import HomeQRButton from '../components/Home/HomeQRButton';
import HomeQRModal from '../components/Home/HomeQRModal';
import HomeShortcuts from '../components/Home/HomeShortcuts';
import '../components/Home/Home.css';
import './HomePage.css';
import {Col, Container, Row} from "react-bootstrap";
import {useNavigate} from "react-router-dom";
import {useConfig} from "../context/ConfigContext";
import {getShopIdFromToken, getUserRoleFromToken} from '../auth/authUtils';
import { FiBarChart2, FiPackage, FiTrendingUp } from 'react-icons/fi';

export default function HomePage(){

    const navigate = useNavigate();
    const shopId = getShopIdFromToken();
    
    const [isFillShopBranchData, setIsFillShopBranchData] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [qr, setQr] = useState();

    const [shopBranch, setShopBranch] = useState();
    const [user, setUser] = useState();
    const [shopSubdomain, setShopSubdomain] = useState();

    // MODULOS DE CONFIGURACIONES DE NEGOCIO
    const { features, shopPlanInfo } = useConfig();
    const userRole = getUserRoleFromToken();
    const reportesFeature = features.find(feature => feature.name === 'REPORTES');
    const expirationsProductFeature = features.find(feature => feature.name === 'VENCIMIENTOS DE PRODUCTOS');

    useEffect(() => {

        document.title = 'QReate';

        getUser();

        axios.get(process.env.REACT_APP_API_SHOP_BRANCH_ROUTE, {
            withCredentials: true
        })
        .then((response) => {
            setIsFillShopBranchData(true);
            setShopBranch(response.data);
        })
        .catch(() => {
            setIsFillShopBranchData(false)
        })
        .finally(() => {
            setIsLoading(false)
        });

        getShopBranches(shopId);

        // Verificar feature de vencimientos y obtener alertas temporales
        if (expirationsProductFeature && expirationsProductFeature.status) {
            axios.get(process.env.REACT_APP_API_TEMPORAL_ALERT_ROUTE, {
                withCredentials: true
            })
                .then((alertResponse) => {
                    alertResponse.data.forEach(alert => {
                        toast.warning(<div dangerouslySetInnerHTML={{ __html: alert.message }} />, {
                            position: "top-right",
                            autoClose: false,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            style: {
                                backgroundColor: 'rgb(223,78,78)',
                                color: 'white',
                                fontWeight: 'bold',
                            },
                        });
                    });
                })
                .catch((error) => {
                    console.error('Error al obtener alertas temporales:', error);
                });
        }

    }, []);

    const getUser = () => {
        axios.get(process.env.REACT_APP_API_USER_BY_USER_ROUTE, {
            withCredentials: true
        })
            .then((response) => {
                setUser(response.data);
            })
            .catch(() => {
            })
            .finally(() => {
                setIsLoading(false)
            });
    }

    const generateQR = () => {
        axios.get(process.env.REACT_APP_API_GENERATE_QR_ROUTE, {
            withCredentials: true,
            responseType: 'arraybuffer'
        })
        .then(response => {
            const blob = new Blob([response.data], { type: 'image/png' });
            const imageUrl = URL.createObjectURL(blob);
            // Decodificar la URL
            const decodedUrl = decodeURIComponent(imageUrl);
            setQr(decodedUrl);
        })
        .catch(error => {
            alertError(error);
            console.error(error)
        });
    }

    const getShopBranches = (shopId) => {
        axios.get(process.env.REACT_APP_API_SHOP_SUBDOMAIN_BYSHOPID_ROUTE, {
            params: {
                shopId: shopId
            }
        })
            .then(response => {
                setShopSubdomain(response.data);
            })
            .catch(error => {
                console.error(error);
            });
    }

    function alertError(error, fallback = 'Ocurrió un error, vuelve a intentar'){
        
        Swal.fire({
          title: 'Upsss',
          text: getApiErrorMessage(error, fallback),
          icon: 'error',
          timer: 1500,
          confirmButtonColor: 'rgb(246, 139, 127)',
          showConfirmButton: false,
        });

    }

    const download = () => {
        const url = qr;
        const a = document.createElement('a');
        a.href = url;
        a.download = 'qr_code.png';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    if (isLoading) {
        return <Loading/>; // Muestra un mensaje de carga mientras se realiza la petición
    }

    const handleRedirect = (url) => {
        navigate(url);
    }

    return (
      <Container fluid className="home-page">
          <div className="home-page-inner">
              {!isLoading && user && shopBranch && (
                  <HomeTitle
                      shopBranchName={shopBranch.name}
                      nameUser={user.name}
                      lastnameUser={user.lastName}
                      username={user.username}
                      shopPlanInfo={shopPlanInfo}
                  />
              )}

              {!isFillShopBranchData ? (
                  <HomeNoShop />
              ) : (
                  <Container className="cardListContainer">
                      <div className="home-actions-grid">
                          <HomeCardLink
                              to={shopSubdomain?.url}
                              title="Carta"
                              subtitle="Ver tu carta digital lista para compartir"
                          />
                          <HomeQRButton
                              action={generateQR}
                              title="QR"
                              subtitle="Descargá el código QR de tu carta"
                          />
                      </div>

                      <HomeShortcuts />

                      {reportesFeature && reportesFeature.status && userRole === 'ADMIN' ? (
                          <div className="home-reports-section">
                              <h2 className="home-section-title">Reportes</h2>
                              <Row className="home-reports-grid">
                                  <Col xs={12} md={4} className="cardReport">
                                      <button
                                          type="button"
                                          className="home-report-card"
                                          onClick={() => handleRedirect('/reporteVentas')}
                                      >
                                          <span className="home-report-icon" aria-hidden>
                                              <FiTrendingUp size={18} />
                                          </span>
                                          <span className="home-report-label">Reporte de ventas</span>
                                      </button>
                                  </Col>
                                  <Col xs={12} md={4} className="cardReport">
                                      <button
                                          type="button"
                                          className="home-report-card"
                                          onClick={() => handleRedirect('/reporteProductos')}
                                      >
                                          <span className="home-report-icon" aria-hidden>
                                              <FiPackage size={18} />
                                          </span>
                                          <span className="home-report-label">Reporte de productos</span>
                                      </button>
                                  </Col>
                                  <Col xs={12} md={4} className="cardReport">
                                      <button
                                          type="button"
                                          className="home-report-card"
                                          onClick={() => handleRedirect('/reporteMovimientos')}
                                      >
                                          <span className="home-report-icon" aria-hidden>
                                              <FiBarChart2 size={18} />
                                          </span>
                                          <span className="home-report-label">
                                              Movimientos — balance ingresos y egresos
                                          </span>
                                      </button>
                                  </Col>
                              </Row>
                          </div>
                      ) : null}
                  </Container>
              )}
          </div>
          <HomeQRModal qr={qr} download={download} />
      </Container>
    );
}